export const MB = 1 * 1024 * 1024;
export const FILE_SIZE = 5;

export const RESUME_UPDATE = {
  HEADING: "heading",
  BODY: "body",
};

export const ORGANIZATION_TYPE = {
  "Public Company": 1,
  "Self employed": 2,
  "Government agency": 3,
  Nonprofit: 4,
  "Sole proprietorship": 5,
  "Privately held": 6,
  Partnership: 7,
};

export const COMPANY_SIZE = {
  "0-1": 1,
  "2-10": 2,
  "11-50": 3,
  "51-200": 4,
  "201-500": 5,
  "501-1,000": 6,
  "1,001-5,000": 7,
  "5,001-10,000": 8,
  "10,000+": 9,
};

export const COMPANY_SIZE_MAP_TO_LABEL = {
  1: "0-1",
  2: "2-10",
  3: "11-50",
  4: "51-200",
  5: "201-500",
  6: "501-1,000",
  7: "1,001-5,000",
  8: "5,001-10,000",
  9: "10,000+",
};

export const INDUSTRIES = {
  Accounting: 1,
  "Airlines/Aviation": 2,
  "Alternative Dispute Resolution": 3,
  "Alternative Medicine": 4,
  Animation: 5,
  "Apparel & Fashion": 6,
  "Architecture & Planning": 7,
  "Arts and Crafts": 8,
  Automotive: 9,
  "Aviation & Aerospace": 10,
  Banking: 11,
  Biotechnology: 12,
  "Broadcast Media": 13,
  "Building Materials": 14,
  "Business Supplies and Equipment": 15,
  "Capital Markets": 16,
  Chemicals: 17,
  "Civic & Social Organization": 18,
  "Civil Engineering": 19,
  "Commercial Real Estate": 20,
  "Computer & Network Security": 21,
  "Computer Games": 22,
  "Computer Hardware": 23,
  "Computer Networking": 24,
  "Computer Software": 25,
  Construction: 26,
  "Consumer Electronics": 27,
  "Consumer Goods": 28,
  "Consumer Services": 29,
  Cosmetics: 30,
  Dairy: 31,
  "Defense & Space": 32,
  Design: 33,
  "Education Management": 34,
  "E-Learning": 35,
  "Electrical/Electronic Manufacturing": 36,
  Entertainment: 37,
  "Environmental Services": 38,
  "Events Services": 39,
  "Executive Office": 40,
  "Facilities Services": 41,
  Farming: 42,
  "Financial Services": 43,
  "Fine Art": 44,
  Fishery: 45,
  "Food & Beverages": 46,
  "Food Production": 47,
  "Fund-Raising": 48,
  Furniture: 49,
  "Gambling & Casinos": 50,
  "Glass, Ceramics & Concrete": 51,
  "Government Administration": 52,
  "Government Relations": 53,
  "Graphic Design": 54,
  "Health, Wellness and Fitness": 55,
  "Higher Education": 56,
  "Hospital & Health Care": 57,
  Hospitality: 58,
  "Human Resources": 59,
  "Import and Export": 60,
  "Individual & Family Services": 61,
  "Industrial Automation": 62,
  "Information Services": 63,
  "Information Technology and Services": 64,
  Insurance: 65,
  "International Affairs": 66,
  "International Trade and Development": 67,
  Internet: 68,
  "Investment Banking": 69,
  "Investment Management": 70,
  Judiciary: 71,
  "Law Enforcement": 72,
  "Law Practice": 73,
  "Legal Services": 74,
  "Legislative Office": 75,
  "Leisure, Travel & Tourism": 76,
  Libraries: 77,
  "Logistics and Supply Chain": 78,
  "Luxury Goods & Jewelry": 79,
  Machinery: 80,
  "Management Consulting": 81,
  Maritime: 82,
  "Market Research": 83,
  "Marketing and Advertising": 84,
  "Mechanical or Industrial Engineering": 85,
  "Media Production": 86,
  "Medical Devices": 87,
  "Medical Practice": 88,
  "Mental Health Care": 89,
  Military: 90,
  "Mining & Metals": 91,
  "Motion Pictures and Film": 92,
  "Museums and Institutions": 93,
  Music: 94,
  Nanotechnology: 95,
  Newspapers: 96,
  "Non-Profit Organization Management": 97,
  "Oil & Energy": 98,
  "Online Media": 99,
  "Outsourcing/Offshoring": 100,
  "Package/Freight Delivery": 101,
  "Packaging and Containers": 102,
  "Paper & Forest Products": 103,
  "Performing Arts": 104,
  Pharmaceuticals: 105,
  Philanthropy: 106,
  Photography: 107,
  Plastics: 108,
  "Political Organization": 109,
  "Primary/Secondary Education": 110,
  Printing: 111,
  "Professional Training & Coaching": 112,
  "Program Development": 113,
  "Public Policy": 114,
  "Public Relations and Communications": 115,
  "Public Safety": 116,
  Publishing: 117,
  "Railroad Manufacture": 118,
  Ranching: 119,
  "Real Estate": 120,
  "Recreational Facilities and Services": 121,
  "Religious Institutions": 122,
  "Renewable & Environment": 123,
  Research: 124,
  Restaurants: 125,
  Retail: 126,
  "Security and Investigations": 127,
  Semiconductors: 128,
  Shipbuilding: 129,
  "Sporting Goods": 130,
  Sports: 131,
  "Staffing and Recruiting": 132,
  Supermarkets: 133,
  Telecommunications: 134,
  Textiles: 135,
  "Think Tanks": 136,
  Tobacco: 137,
  "Translation and Localization": 138,
  "Transportation/Trucking/Railroad": 139,
  Utilities: 140,
  "Venture Capital & Private Equity": 141,
  Veterinary: 142,
  Warehousing: 143,
  Wholesale: 144,
  "Wine and Spirits": 145,
  Wireless: 146,
  "Writing and Editing": 147,
  "Motor Vehicle Manufacturing": 148,
};

export const INDUSTRIES_MAP_TO_LABEL = {
  1: "Accounting",
  2: "Airlines/Aviation",
  3: "Alternative Dispute Resolution",
  4: "Alternative Medicine",
  5: "Animation",
  6: "Apparel & Fashion",
  7: "Architecture & Planning",
  8: "Arts and Crafts",
  9: "Automotive",
  10: "Aviation & Aerospace",
  11: "Banking",
  12: "Biotechnology",
  13: "Broadcast Media",
  14: "Building Materials",
  15: "Business Supplies and Equipment",
  16: "Capital Markets",
  17: "Chemicals",
  18: "Civic & Social Organization",
  19: "Civil Engineering",
  20: "Commercial Real Estate",
  21: "Computer & Network Security",
  22: "Computer Games",
  23: "Computer Hardware",
  24: "Computer Networking",
  25: "Computer Software",
  26: "Construction",
  27: "Consumer Electronics",
  28: "Consumer Goods",
  29: "Consumer Services",
  30: "Cosmetics",
  31: "Dairy",
  32: "Defense & Space",
  33: "Design",
  34: "Education Management",
  35: "E-Learning",
  36: "Electrical/Electronic Manufacturing",
  37: "Entertainment",
  38: "Environmental Services",
  39: "Events Services",
  40: "Executive Office",
  41: "Facilities Services",
  42: "Farming",
  43: "Financial Services",
  44: "Fine Art",
  45: "Fishery",
  46: "Food & Beverages",
  47: "Food Production",
  48: "Fund-Raising",
  49: "Furniture",
  50: "Gambling & Casinos",
  51: "Glass, Ceramics & Concrete",
  52: "Government Administration",
  53: "Government Relations",
  54: "Graphic Design",
  55: "Health, Wellness and Fitness",
  56: "Higher Education",
  57: "Hospital & Health Care",
  58: "Hospitality",
  59: "Human Resources",
  60: "Import and Export",
  61: "Individual & Family Services",
  62: "Industrial Automation",
  63: "Information Services",
  64: "Information Technology and Services",
  65: "Insurance",
  66: "International Affairs",
  67: "International Trade and Development",
  68: "Internet",
  69: "Investment Banking",
  70: "Investment Management",
  71: "Judiciary",
  72: "Law Enforcement",
  73: "Law Practice",
  74: "Legal Services",
  75: "Legislative Office",
  76: "Leisure, Travel & Tourism",
  77: " Libraries",
  78: "Logistics and Supply Chain",
  79: "Luxury Goods & Jewelry",
  80: "Machinery",
  81: "Management Consulting",
  82: "Maritime",
  83: "Market Research",
  84: "Marketing and Advertising",
  85: "Mechanical or Industrial Engineering",
  86: "Media Production",
  87: "Medical Devices",
  88: "Medical Practice",
  89: "Mental Health Care",
  90: "Military",
  91: "Mining & Metals",
  92: "Motion Pictures and Film",
  93: "Museums and Institutions",
  94: "Music",
  95: "Nanotechnology",
  96: "Newspapers",
  97: "Non-Profit Organization Management",
  98: "Oil & Energy",
  99: "Online Media",
  100: "Outsourcing/Offshoring",
  101: "Package/Freight Delivery",
  102: "Packaging and Containers",
  103: "Paper & Forest Products",
  104: "Performing Arts",
  105: "Pharmaceuticals",
  106: "Philanthropy",
  107: "Photography",
  108: "Plastics",
  109: "Political Organization",
  110: "Primary/Secondary Education",
  111: "Printing",
  112: "Professional Training & Coaching",
  113: "Program Development",
  114: "Public Policy",
  115: "Public Relations and Communications",
  116: "Public Safety",
  117: "Publishing",
  118: "Railroad Manufacture",
  119: "Ranching",
  120: "Real Estate",
  121: "Recreational Facilities and Services",
  122: "Religious Institutions",
  123: "Renewable & Environment",
  124: "Research",
  125: "Restaurants",
  126: "Retail",
  127: "Security and Investigations",
  128: "Semiconductors",
  129: "Shipbuilding",
  130: "Sporting Goods",
  131: "Sports",
  132: "Staffing and Recruiting",
  133: "Supermarkets",
  134: "Telecommunications",
  135: "Textiles",
  136: "Think Tanks",
  137: "Tobacco",
  138: "Translation and Localization",
  139: "Transportation/Trucking/Railroad",
  140: "Utilities",
  141: "Venture Capital & Private Equity",
  142: "Veterinary",
  143: "Warehousing",
  144: "Wholesale",
  145: "Wine and Spirits",
  146: "Wireless",
  147: "Writing and Editing",
  148: "Motor Vehicle Manufacturing",
};

export const EMPLOYMENT_TYPES = {
  "Full Time": 1,
  "Part Time": 2,
  Contract: 3,
  Internship: 4,
  Temporary: 5,
  Volunteer: 6,
  Other: 7,
};

export const EMPLOYMENT_TYPES_MAP_TO_LABEL = {
  1: "Full Time",
  2: "Part Time",
  3: "Contract",
  4: "Internship",
  5: "Temporary",
  6: "Volunteer",
  7: "Other",
};

export const WORKPLACE_TYPES = {
  Remote: 1,
  "On-Site": 2,
};

export const WORLPLACE_TYPES_MAP_TO_LABEL = {
  1: "Remote",
  2: "On-Site",
};

export const EXPERIENCE_LEVEL = {
  "Entry Level": 1,
  "Mid Senior Level": 2,
  Director: 3,
  Executive: 4,
  Internship: 5,
  Associate: 6,
  "Not Applicable": 7,
};

export const EXPERIENCE_LEVEL_MAP_TO_LABEL = {
  1: "Entry Level",
  2: "Mid Senior Level",
  3: "Director",
  4: "Executive",
  5: "Internship",
  6: "Associate",
  7: "Not Applicable",
};

export const PRIVACY_STATUS = {
  Private: 1,
  Protected: 2,
  Public: 3,
};

export const STIPENDS_TYPE = {
  Range: 1,
  "Starting amount": 2,
  "Maximum amount": 3,
  "Exact amount": 4,
  "Estimated average": 5,
};

export const STIPEND_TYPE_MAP_TO_VALUE = {
  1: "Range",
  2: "Starting amount",
  3: "Maximum amount",
  4: "Exact amount",
};

export const CURRENCY_TYPE = {
  INR: 1,
  USD: 2,
  EUR: 3,
  GBP: 4,
};

export const CURRENCY_TYPE_MAP_TO_VALUE = {
  1: "INR",
  2: "USD",
  3: "EUR",
  4: "GBP",
};

export const DURATION_TYPE = {
  Hour: 1,
  Day: 2,
  Week: 3,
  Month: 4,
  Year: 5,
};

export const DURATION_TYPE_MAP_TO_VALUE = {
  1: "Hour",
  2: "Day",
  3: "Week",
  4: "Month",
  5: "Year",
};

export const APPLICATION_STATUS_TYPES = {
  Draft: 1,
  Applied: 2,
  Shortlisted: 3,
  Rejected: 4,
  Hired: 5,
};

export const ONBOARDING_STAGES = {
  "Stage One": 1,
  "Stage Two": 2,
  "Stage Three": 3,
  "Stage Four": 4,
  "Stage Five": 5,
  "Stage Six": 6,
};

export const MENTOR_IDS = [
  { gamePlayerId: "63f33f2c4012110013abb406" },
  { gamePlayerId: "62ce7c572f0b9f0013de2a23" },
  { gamePlayerId: "63788d72d43ccb0013208d5c" },
  { gamePlayerId: "63c945db96b1220014d6493f" },
];
